import { FC } from 'react';

import Card from '../../../components/Card/Card';
import CardItem from '../../../components/Card/CardItem';
import { IconNames } from '../../../components/MaterialIcon/MaterialIcon';
import { Separator } from '../../../components/Separator/Separator';
import style from './AboutAppointment.module.scss';

export interface AboutAppointmentContent {
  description: string;
  icon: IconNames;
  iconColor?: string;
  title?: string;
}

export interface AboutAppointmentProps {
  content: AboutAppointmentContent[];
  title: string;
}

export const AboutAppointment: FC<AboutAppointmentProps> = ({ title, content }) => {
  return (
    <section className={style.aboutAppointment}>
      <h2 className={style.title}>{title}</h2>
      {content.map(({ description, icon, title, iconColor }, index) => (
        <Card className={style.card} key={description}>
          <CardItem className={style.item} icon={icon} iconColor={iconColor}>
            <div className={style.itemContainer}>
              {index === 0 ? <h3>{title}</h3> : null}
              <p dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </CardItem>
          {index < content.length - 1 && <Separator />}
        </Card>
      ))}
    </section>
  );
};
